<div>
    <div style="display:flex; flex-direction: column;">
      <div style="display:flex; margin-top: 2rem;"><span class="text-bold" translate>ON_PREMISE_SECTION.CHOOSEINSTANCEKEY_TOOLTIP</span></div>
      <div><p style="font-size: 0.75rem">{{this.instanceInfo}}</p></div>
      <div><mat-form-field appearance="outline">
          <mat-select
              (selectionChange)="onInstanceChange($event)"
              [(ngModel)]="this.magoWebService.selectedInstanceKey"
              [disabled]="this.magoWebService.isModifyStatus"
          >
              <mat-option value=""><span translate>INDUSTRY_CONFIGURATOR.SELECT</span> </mat-option>
              <mat-option *ngFor="let instance of this.magoWebService?.instances" [value]="instance.InstanceKey"
                  >{{ instance.Description }}({{ instance.InstanceKey }})</mat-option
              >
          </mat-select>
      </mat-form-field></div>
    </div>
</div>
